
import React from 'react';
import { Snackbar, Alert, alpha, Slide } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

export default function SuccessNotification({ open, message, onClose, severity = "success" }) {
    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            TransitionComponent={TransitionUp}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                variant="filled"
                icon={<CheckCircleIcon fontSize="inherit" />}
                sx={{
                    borderRadius: '12px',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                    bgcolor: severity === 'success' ? '#000000' : undefined,
                    minWidth: '300px',
                    '& .MuiAlert-icon': {
                        fontSize: 24
                    }
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}
